import React, { useState } from 'react'

import MenuItem from 'karrierhub-ui/dist/common/src/components/MenuItem'
import { DefaultHeaderComponent } from 'karrierhub-ui/dist/common/src/components/Paper'
import Menu from 'karrierhub-ui/dist/common/src/components/Menu'
import { MegaMenu } from '../MegaMenu'
import clsx from 'clsx'
import ArrowDownIcon from 'karrierhub-ui/dist/common/src/svg/ArrowDownIcon'

export default function DesktopMenu(props) {

    const { MenuProps, menu, classNames, size } = props

    const {
        PaperProps = {},
        PopoverProps = {},
        className,
        classes = {},
        ...RestMenuProps
    } = MenuProps

    return menu?.length && menu.map(({
                                         items,
                                         menuType,
                                         desktopMegaMenuStaticContent,
                                         disableMegaMenu,
                                         role,
                                         ...rest
                                     }, i) => {

        if (!items?.length) {
            return <MenuItem
                size={size}
                variant={'text'}
                {...rest}
                key={i}
                fullWidth={false}
            />
        }

        let setTitle

        const HeaderComponent = (props) => {

            const [title, setTitleChildren] = useState(false)

            setTitle = setTitleChildren

            return (
                <DefaultHeaderComponent {...props} title={title} />
            )
        }

        function getSetTitle() {
            return setTitle
        }

        return <Menu
            key={i}
            MenuItemProps={{
                size,
                color: 'secondary',
                variant: 'contained',
                ...RestMenuProps.MenuItemProps ? { ...RestMenuProps.MenuItemProps } : {}
            }}
            menu={disableMegaMenu ?
                items :
                [{
                    Component: () => {

                        return (
                            <MegaMenu
                                classNames={classNames}
                                menu={items}
                                MenuBaseProps={{
                                    ...RestMenuProps,
                                    menuKey: RestMenuProps.menuKey ? RestMenuProps.menuKey + 'Desktop' : 'menuDesktop',
                                    PaperProps: {
                                        size: 'none',
                                        style: {
                                            width: '100%'
                                        },
                                        elevation: 0
                                    },
                                    DefaultPaperProps: {
                                        size: undefined,
                                        style: undefined,
                                        elevation: undefined
                                    },
                                    MenuItemProps: {
                                        size,
                                        color: 'secondary',
                                        variant: 'contained',
                                        ...RestMenuProps.MenuItemProps ? { ...RestMenuProps.MenuItemProps } : {}
                                    },
                                    classes: {
                                        ...classes,
                                        popoverPaper: classNames.menuPopoverPaper,
                                        modal: classNames.menuModal
                                    }
                                }}
                                getSetTitle={getSetTitle}
                                children={desktopMegaMenuStaticContent}
                                forceOpen={true}
                            />
                        )
                    }
                }]
            }
            anchorComponentSetActiveWhenOpen={true}
            PaperProps={{
                color: 'paper1',
                size: 'default',
                ...PaperProps,
                className: clsx(
                    classNames.desktopMenu,
                    className,
                    PaperProps.className
                ),
                ContentComponentProps: {
                    HeaderComponent
                }
            }}
            PopoverProps={{
                ...PopoverProps,
                AnchorComponent: PopoverProps?.AnchorComponent ?
                    PopoverProps.AnchorComponent : MenuItem,
                AnchorComponentProps: {
                    size,
                    variant: 'text',
                    endIcon: <ArrowDownIcon />,
                    ...PopoverProps?.AnchorComponentProps ? { ...PopoverProps.AnchorComponentProps } : {},
                    ...rest,
                    fullWidth: false
                },
                popperOptions: {
                    placement: 'bottom'
                }
            }}
            classes={{
                ...classes,
                popoverPaper: classNames.menuPopoverPaperDesktop,
                modal: !(desktopMegaMenuStaticContent) ? clsx(classNames.menuModalDesktop, classNames.menuModalDesktopWithoutStaticContent) : classNames.menuModalDesktop
            }}
        />
    })
}
